import { supabase } from './supabaseClient';

export const handleOAuthCallback = async () => {
  try {
    console.log('Processing OAuth callback...');
    
    // Wait a bit for the session to be fully established
    await new Promise(resolve => setTimeout(resolve, 500));
    
    // Get the session from Supabase
    const { data: { session }, error } = await supabase.auth.getSession();
    
    if (error) {
      console.error('Error getting session:', error);
      throw error;
    }

    if (!session) {
      console.error('No session found after OAuth');
      throw new Error('No session found');
    }

    console.log('Session obtained:', session.user.email);

    // Check if profile exists
    const { data: existingProfile, error: profileError } = await supabase
      .from('profiles')
      .select('*')
      .eq('user_id', session.user.id)
      .single();

    if (profileError && profileError.code !== 'PGRST116') {
      console.error('Profile fetch error:', profileError);
    }

    console.log('Profile check:', existingProfile ? 'exists' : 'new user');

    const isNewUser = !existingProfile || !existingProfile.full_name;

    // Create or update profile with session data
    const profileData = {
      user_id: session.user.id,
      email: session.user.email,
      full_name: session.user.user_metadata?.full_name || session.user.user_metadata?.name || '',
      profile_photo_url: session.user.user_metadata?.avatar_url || session.user.user_metadata?.picture || '',
      updated_at: new Date().toISOString()
    };

    if (isNewUser) {
      // Create new profile
      const { error: insertError } = await supabase
        .from('profiles')
        .insert({
          ...profileData,
          created_at: new Date().toISOString()
        });

      if (insertError) {
        console.error('Error creating profile:', insertError);
      }
    } else {
      // Update existing profile
      const { error: updateError } = await supabase
        .from('profiles')
        .update(profileData)
        .eq('user_id', session.user.id);

      if (updateError) {
        console.error('Error updating profile:', updateError);
      }
    }

    // Store complete user data in localStorage
    const userData = {
      userId: session.user.id,
      email: session.user.email,
      full_name: profileData.full_name,
      profile_photo_url: profileData.profile_photo_url,
      isLoggedIn: true,
      loginTime: new Date().toISOString(),
      sessionExpiry: session.expires_at
    };

    localStorage.setItem('currentUser', JSON.stringify(userData));

    console.log('User data stored in localStorage');

    // Return redirect path
    if (isNewUser) {
      console.log('Redirecting to profile setup');
      return '/profile?new=true';
    } else {
      console.log('Redirecting to search');
      return '/search';
    }
  } catch (error) {
    console.error('Error in handleOAuthCallback:', error);
    throw error;
  }
};
